import React from "react";
import { Link } from "react-router-dom";

const Mailto = ({ action, label }:any) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location.href = action;
                e.preventDefault();
            }}
            className="btn btn-sm btn-outline-secondary me-md-2"
            role="button"
            style={{textDecoration:'none'}}
        >
            <i className='zmdi zmdi-mail-reply'></i> {label}
        </Link>
    );
};

export default Mailto;